import { useState, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './FJPreviewModal.module.less';
import FJModalClose from '../FJModalClose/FJModalClose';
import FJLocalStore from '../../../store/FJLocalStore';
import DownloadIcon from '../../../assets/svg/download.svg?react';
import DownloadBlackIcon from '../../../assets/svg/download_black.svg?react';
import ApplyIcon from '../../../assets/svg/apply.svg?react';
import EditIcon from '../../../assets/svg/edit.svg?react';
import AddToMediaIcon from '../../../assets/svg/add-to-media.svg?react';
import CopyIcon from '../../../assets/svg/copy.svg?react';
import EditSfxIcon from '../../../assets/svg/edit_sfx.svg?react';
import FJConstant from '../../../constants/FJConstant';
import classNames from 'classnames';
import FJUtil from '../../../util/FJUtil';
import FJMessageStore from '../../../store/FJMessageStore';
import FJVerticalScroller from '../../../common/components/FJScroller/FJVerticalScroller';
import FJAppConstant from '../../../constants/FJAppConstant';
import FJImageItemPreview from '../../../common/components/FJImageItemPreview/FJImageItemPreview';
import FJVideoContent from '../../../common/components/FJVideoPlayer/FJVideoContent.jsx';
import FJImageItemIconBox from '../../../common/components/FJImageItemPreview/FJImageItemIconBox.jsx';
import PreviewGradientArrow from '../../../assets/svg/preview-gradient-arrow.svg?react';
import FJImage from '../../../common/components/FJImage/FJImage.jsx';
import FJAudioPreview from './FJAudioPreview.jsx';
import Download from '../../../lib/download.js';
import FJAudioTag from '../../../common/components/FJAudioTag/FJAudioTag.jsx';
import FJToolTip from '../../../common/components/FJToolTip/FJToolTip.jsx';
import FJButton, { FJButtonType } from '../../../common/components/FJButton/FJButton.jsx';

const FJPreviewModal = props => {
    const {
        appType,
        data = {},
        onClose,
        onDownload,
        onDelete,
        onEdit,
        addAsScene,
        onEditSfx,
        addToMedia,
        shareToSociety,
        isActiveNext,
        isActivePrevious,
        switchPreview,
        addAsEditPageModalBtuStatus,
        isApplyButton,
        onApply,
        active,
        isAudioGenerator,
        isVideoGeneration,
        isVideoRemoveBg,
        isVideoDub,
        garment,
    } = props;
    const { imgUrl, originalUrl, type, textToImagePrompt, videoUrl, prompt, width, height, generationType, ratio } =
        data;
    const { audioUrl, coverUrl, lyrics, audioName, audioTagType } = data;

    const videoContentRef = useRef(null);
    const audioRef = useRef(null);
    const [stateIsDownloadLoading, setStateIsDownloadLoading] = useState(false);

    const infoList = useMemo(() => {
        return FJUtil.parseModalInfoList(data, appType);
    }, [data, appType]);

    const _copyTextToImagePrompt = () => {
        if (isVideoGeneration || isVideoDub) {
            FJUtil.copyText(prompt);
        } else if (isAudioGenerator) {
            FJUtil.copyText(prompt || lyrics);
        } else {
            FJUtil.copyText(textToImagePrompt);
        }
        FJMessageStore.addMessage(FJLocalStore._('copied-successfully'));
    };

    const _downloadImage = async () => {
        try {
            const blob = await FJUtil.downloadImageCacheAvoidance(coverUrl);
            const fileName = FJUtil.getUseFileName(audioName, '.png');
            Download(blob, fileName, 'image/png');
        } catch (e) {
            FJMessageStore.addMessage(FJLocalStore._('failed-to-download-please-try-again'), 'error');
        }
    };

    const _onDownload = () => {
        setStateIsDownloadLoading(true);
        onDownload(() => {
            setStateIsDownloadLoading(false);
        });
    };

    const _onRefresh = () => {
        audioRef.current.reloadCover();
    };

    const isShowComparison =
        appType !== FJAppConstant.TEXT_TO_IMAGE &&
        appType !== FJAppConstant.IMAGE_EXTENDER &&
        appType !== FJAppConstant.IMAGE_ENHANCER &&
        appType !== FJAppConstant.PHOTO_RESTORATION &&
        appType !== FJAppConstant.PHOTO_COLORIZE &&
        appType !== FJAppConstant.VIDEO_REMOVE_BG;

    const isShowSlideCompare =
        appType === FJAppConstant.IMAGE_ENHANCER ||
        appType === FJAppConstant.PHOTO_RESTORATION ||
        appType === FJAppConstant.PHOTO_COLORIZE;

    const isShowDeleteIcon = type === FJConstant.HISTORY;

    const isShowEditIcon = appType === FJAppConstant.PHOTO_REMOVE_BG || appType === FJAppConstant.VIDEO_REMOVE_BG;

    const isShowAiSfxButton = appType === FJAppConstant.AI_VIDEO_GENERATOR;

    const _renderGarment = () => {
        return (
            <div className={styles.garment_box}>
                <div className={styles.garment_title}>{FJLocalStore._('clothes')}</div>
                <FJImage
                    imgSrc={garment}
                    boxClassName={styles.garment_img_box}
                    imgClassName={styles.garment_img}
                    isShowLoading={true}
                />
                <div className={styles.garment_line} />
            </div>
        );
    };

    const _renderButton = () => {
        if (window.isEditPage) {
            return (
                <>
                    <FJButton
                        className={classNames(styles.btn, styles.margin_bottom_10)}
                        textClassName={styles.btn_text}
                        icon={isApplyButton ? <ApplyIcon /> : <AddToMediaIcon />}
                        text={FJLocalStore._(isApplyButton ? 'apply' : 'add-to-media')}
                        onClick={isApplyButton ? onApply : addToMedia}
                        type={FJButtonType.GRADIENT}
                        strokeColor={'#FFF'}
                    />
                    <FJButton
                        className={classNames(styles.btn, styles.margin_bottom_37)}
                        textClassName={styles.btn_text}
                        icon={<DownloadBlackIcon />}
                        text={FJLocalStore._('download')}
                        onClick={_onDownload}
                        isLoading={stateIsDownloadLoading}
                    />
                </>
            );
        } else {
            return (
                <>
                    <FJButton
                        className={classNames(styles.btn, styles.margin_bottom_10)}
                        textClassName={styles.btn_text}
                        icon={<DownloadIcon />}
                        text={FJLocalStore._('download')}
                        onClick={_onDownload}
                        type={FJButtonType.GRADIENT}
                        isLoading={stateIsDownloadLoading}
                        strokeColor={'#FFF'}
                    />

                    {!isShowAiSfxButton ? (
                        <FJButton
                            className={classNames(styles.btn, styles.margin_bottom_30)}
                            textClassName={styles.btn_text}
                            icon={<EditIcon />}
                            text={FJLocalStore._('use-in-a-design')}
                            onClick={addAsScene}
                            type={FJButtonType.DEFAULT}
                            isLoading={addAsEditPageModalBtuStatus === FJConstant.LOADING}
                        />
                    ) : (
                        <div className={classNames(styles.ai_sfx_btn_box, styles.margin_bottom_30)}>
                            <FJButton
                                className={classNames(styles.btn)}
                                textClassName={styles.btn_text}
                                icon={<EditIcon />}
                                text={FJLocalStore._('edit')}
                                onClick={addAsScene}
                            />

                            <FJButton
                                className={classNames(styles.btn)}
                                textClassName={styles.btn_text}
                                icon={<EditSfxIcon />}
                                text={FJLocalStore._('ai-sfx-1')}
                                onClick={onEditSfx}
                            />
                        </div>
                    )}
                </>
            );
        }
    };

    const renderLeftContent = () => {
        if (isVideoRemoveBg || isVideoDub) {
            return (
                <div className={styles.video_box} ref={videoContentRef}>
                    <FJVideoContent
                        url={videoUrl}
                        isLoop={true}
                        ratio={width / height}
                        style={{ position: 'absolute' }}
                        isShowTransparentBG={isVideoRemoveBg}
                    />
                    <FJImageItemIconBox
                        onDelete={onDelete}
                        shareToSociety={shareToSociety}
                        isShowDeleteIcon={true}
                        isShowComparison={false}
                        imageLoadingError={false}
                        disabledComparison={true}
                        isComparisonActive={false}
                        isShowEditIcon={isVideoRemoveBg ? isShowEditIcon : false}
                        onEdit={isVideoRemoveBg ? onEdit : undefined}
                    />
                </div>
            );
        } else if (isVideoGeneration) {
            return (
                <div className={styles.video_box} ref={videoContentRef}>
                    <FJVideoContent url={videoUrl} isLoop={true} ratio={ratio} style={{ position: 'absolute' }} />
                    <FJImageItemIconBox
                        onDelete={onDelete}
                        shareToSociety={shareToSociety}
                        isShowDeleteIcon={true}
                        isShowComparison={false}
                        imageLoadingError={false}
                        disabledComparison={true}
                        isComparisonActive={false}
                    />
                </div>
            );
        } else if (isAudioGenerator) {
            return (
                <div className={styles.video_box}>
                    <FJAudioPreview audioUrl={audioUrl} coverUrl={coverUrl} active={active} ref={audioRef} />
                    <FJImageItemIconBox
                        onDelete={onDelete}
                        shareToSociety={shareToSociety}
                        isShowDeleteIcon={true}
                        isShowComparison={false}
                        imageLoadingError={false}
                        disabledComparison={true}
                        isComparisonActive={false}
                    />
                </div>
            );
        } else {
            return (
                <FJImageItemPreview
                    imgUrl={imgUrl}
                    originalUrl={originalUrl}
                    isShowDeleteIcon={isShowDeleteIcon}
                    isShowComparison={isShowComparison}
                    isShowSlideCompare={isShowSlideCompare}
                    onDelete={onDelete}
                    shareToSociety={shareToSociety}
                    isShowEditIcon={isShowEditIcon}
                    onEdit={onEdit}
                />
            );
        }
    };

    const _onClose = () => {
        onClose();
        if (audioRef && audioRef.current) {
            audioRef.current.reset();
        }
    };

    return (
        <div className={styles.box}>
            <FJModalClose onClick={_onClose} />
            <div
                className={classNames(
                    styles.catalog_icon_box,
                    styles.catalog_left,
                    !isActivePrevious ? styles.disable : '',
                )}
                onClick={() => {
                    switchPreview(false);
                }}
            >
                <PreviewGradientArrow />
            </div>
            <div
                className={classNames(
                    styles.catalog_icon_box,
                    styles.catalog_right,
                    !isActiveNext ? styles.disable : '',
                )}
                onClick={() => {
                    switchPreview(true);
                }}
            >
                <PreviewGradientArrow />
            </div>

            <div className={styles.content}>
                {renderLeftContent()}

                <div className={styles.right}>
                    {_renderButton()}

                    {/*  这里只有文生图和图生图显示 */}
                    {(textToImagePrompt || (prompt && isVideoDub)) && (
                        <>
                            <div className={styles.info_item_prompt}>
                                <div className={styles.info_title_box}>
                                    <span className={styles.info_title}>
                                        {isVideoDub ? FJLocalStore._('video-description') : FJLocalStore._('prompt')}
                                    </span>
                                    <div className={styles.info_title_icon} onClick={_copyTextToImagePrompt}>
                                        <CopyIcon />
                                    </div>
                                </div>
                                <FJVerticalScroller className={classNames(styles.info_content_prompt)}>
                                    {textToImagePrompt || prompt}
                                </FJVerticalScroller>
                            </div>
                            <div className={styles.line}></div>
                        </>
                    )}

                    {isVideoGeneration && (
                        <>
                            {generationType === 'iv' && (
                                <div className={styles.info_item_prompt}>
                                    <div className={styles.info_title_box}>
                                        <span className={styles.info_title}>{FJLocalStore._('image')}</span>
                                    </div>
                                    <FJImage
                                        imgSrc={originalUrl}
                                        boxClassName={styles.img_box}
                                        imgClassName={styles.img}
                                    />
                                </div>
                            )}
                            {prompt && (
                                <div className={styles.info_item_prompt}>
                                    <div className={styles.info_title_box}>
                                        <span className={styles.info_title}>{FJLocalStore._('prompt')}</span>
                                        <div className={styles.info_title_icon} onClick={_copyTextToImagePrompt}>
                                            <CopyIcon />
                                        </div>
                                    </div>
                                    <FJVerticalScroller className={classNames(styles.info_content_prompt)}>
                                        {prompt}
                                    </FJVerticalScroller>
                                </div>
                            )}
                            <div className={styles.line}></div>
                        </>
                    )}

                    {isAudioGenerator && (
                        <div className={styles.info_item_prompt}>
                            <div className={styles.info_title_box}>
                                <span className={styles.info_title}>{FJLocalStore._('music-info')}</span>
                                <FJToolTip title={FJLocalStore._('download-cover')}>
                                    <div className={styles.info_title_icon} onClick={_downloadImage}>
                                        <DownloadBlackIcon />
                                    </div>
                                </FJToolTip>
                            </div>
                            <div className={styles.music_info}>
                                <FJImage
                                    imgSrc={coverUrl}
                                    boxClassName={styles.img_box}
                                    imgClassName={styles.img}
                                    onRefresh={_onRefresh}
                                    isShowLoading={true}
                                />
                                <div className={styles.info_right}>
                                    <div className={styles.name}>{audioName}</div>
                                    <FJAudioTag type={audioTagType} className={styles.tag} />
                                </div>
                            </div>
                        </div>
                    )}

                    {garment && _renderGarment()}

                    {isAudioGenerator && (prompt || lyrics) && (
                        <>
                            <div className={styles.line} style={{ flex: 'none' }}></div>
                            <div className={styles.info_item_prompt} style={{ overflow: 'hidden' }}>
                                <div className={styles.info_title_box}>
                                    <span className={styles.info_title}>
                                        {FJLocalStore._(lyrics ? 'your-lyrics' : 'your-prompt')}
                                    </span>
                                    <div className={styles.info_title_icon} onClick={_copyTextToImagePrompt}>
                                        <CopyIcon />
                                    </div>
                                </div>
                                <FJVerticalScroller className={classNames(styles.info_lyric)}>
                                    {prompt || lyrics}
                                </FJVerticalScroller>
                            </div>
                        </>
                    )}

                    {isAudioGenerator && <div className={styles.line} style={{ flex: 'none' }}></div>}

                    {infoList.map((item, index) => (
                        <div className={styles.info_item} key={index}>
                            <span className={styles.info_title}>{FJLocalStore._(item.title)}</span>
                            <span className={styles.info_content}>{item.content}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
FJPreviewModal.propTypes = {
    appType: PropTypes.string,
    data: PropTypes.object,
    onClose: PropTypes.func,
    onDownload: PropTypes.func,
    onDelete: PropTypes.func,
    addAsScene: PropTypes.func,
    shareToSociety: PropTypes.func,
    isActiveNext: PropTypes.bool,
    isActivePrevious: PropTypes.bool,
    switchPreview: PropTypes.func,
    addAsEditPageModalBtuStatus: PropTypes.string,
    onEdit: PropTypes.func,
    addToMedia: PropTypes.func,
    onApply: PropTypes.func,
    active: PropTypes.bool,
    isApplyButton: PropTypes.bool,
    isAudioGenerator: PropTypes.bool,
    isVideoGeneration: PropTypes.bool,
    isVideoRemoveBg: PropTypes.bool,
    garment: PropTypes.bool,
    isVideoDub: PropTypes.bool,
    onEditSfx: PropTypes.func,
};
export default FJPreviewModal;
